/**
 * QUELLE DEMANDE OUVRIR EN ARRIVANT.
 *
 * Le portail n'a pas de routeur : voyager d'un écran à l'autre se fait par un
 * petit magasin que la destination lit une fois affichée — exactement comme
 * `actesFocus` le fait déjà pour un dossier.
 *
 * Il manquait l'équivalent pour une DEMANDE, et cela se voyait sur le tableau
 * de bord : « Ouvrir le dossier » ouvrait le dossier, « Derniers actes reçus »
 * ouvrait le dossier, et les lignes qui expirent n'ouvraient rien du tout.
 * Or ce qu'on regarde dans les trois cas, c'est UNE demande précise. On la
 * nomme donc, et l'écran des demandes l'ouvre à l'arrivée.
 */
let pending: string | null = null;
const listeners = new Set<() => void>();

/** « En arrivant sur Demandes, ouvre celle-ci. » */
export function setActeOpen(id: string | null): void {
  pending = id;
  listeners.forEach((l) => l());
}

/** Se lit UNE fois et s'efface : c'est une consigne, pas un état. */
export function takeActeOpen(): string | null {
  const v = pending;
  pending = null;
  return v;
}

export function onActeOpen(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}
